// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const AdminAudit = __t.object("AdminAudit", {
  id: __t.u64(),
  at: __t.timestamp(),
  admin: __t.identity(),
  actor: __t.string(),
  action: __t.string(),
  target: __t.string(),
  detail: __t.string(),
});
export type AdminAudit = __Infer<typeof AdminAudit>;

export const AdventureInstance = __t.object("AdventureInstance", {
  id: __t.u64(),
  worldId: __t.u64(),
  partyId: __t.u64(),
  offerId: __t.u64(),
  state: __t.u8(),
  title: __t.string(),
  location: __t.string(),
  blob: __t.byteArray(),
  currentSite: __t.u16(),
  visited: __t.array(__t.u16()),
  cleared: __t.array(__t.u16()),
  cluesFound: __t.array(__t.u16()),
  encounterId: __t.option(__t.u64()),
  encounters: __t.array(__t.u64()),
  startedAt: __t.timestamp(),
  settledAt: __t.option(__t.timestamp()),
  outcomeRow: __t.option(__t.u8()),
  wipes: __t.u8(),
});
export type AdventureInstance = __Infer<typeof AdventureInstance>;

export const BandCall = __t.object("BandCall", {
  id: __t.u64(),
  worldId: __t.u64(),
  caller: __t.identity(),
  partyId: __t.u64(),
  fromParty: __t.u64(),
  kind: __t.u8(),
  offerId: __t.u64(),
  villageId: __t.u64(),
  get asks() {
    return __t.array(CallAsk);
  },
  deadline: __t.timestamp(),
  state: __t.u8(),
  note: __t.string(),
  at: __t.timestamp(),
});
export type BandCall = __Infer<typeof BandCall>;

export const BandCallDue = __t.object("BandCallDue", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  callId: __t.u64(),
});
export type BandCallDue = __Infer<typeof BandCallDue>;

export const BoardPing = __t.object("BoardPing", {
  encounterId: __t.u64(),
  owner: __t.identity(),
  x: __t.i32(),
  y: __t.i32(),
  kind: __t.u8(),
});
export type BoardPing = __Infer<typeof BoardPing>;

export const BookChapter = __t.object("BookChapter", {
  id: __t.u64(),
  worldId: __t.u64(),
  number: __t.u8(),
  title: __t.string(),
  goal: __t.string(),
  summary: __t.string(),
  state: __t.u8(),
  scene: __t.byteArray(),
  jobId: __t.u64(),
  tries: __t.u8(),
  met: __t.u8(),
  missed: __t.u8(),
  openedWeek: __t.u64(),
  openedAt: __t.timestamp(),
});
export type BookChapter = __Infer<typeof BookChapter>;

export const CallAsk = __t.object("CallAsk", {
  owner: __t.identity(),
  answer: __t.u8(),
});
export type CallAsk = __Infer<typeof CallAsk>;

export const CampaignProgress = __t.object("CampaignProgress", {
  worldId: __t.u64(),
  chapter: __t.u8(),
  jobId: __t.u64(),
  writing: __t.bool(),
  lastOffer: __t.u64(),
  lastJumpChapter: __t.u8(),
});
export type CampaignProgress = __Infer<typeof CampaignProgress>;

export const ChronicleEvent = __t.object("ChronicleEvent", {
  id: __t.u64(),
  worldId: __t.u64(),
  seq: __t.u64(),
  at: __t.timestamp(),
  weekIndex: __t.u64(),
  campaign: __t.option(__t.u32()),
  adventure: __t.option(__t.u32()),
  instance: __t.option(__t.u64()),
  pulse: __t.option(__t.u32()),
  kind: __t.byteArray(),
  kindName: __t.string(),
  actors: __t.byteArray(),
  heroIds: __t.array(__t.u64()),
  npcIds: __t.array(__t.u64()),
  causes: __t.array(__t.u64()),
  visibility: __t.u8(),
  visibilityParty: __t.option(__t.u64()),
  visibilityOwner: __t.option(__t.identity()),
  summary: __t.string(),
  rulesetVersion: __t.u32(),
});
export type ChronicleEvent = __Infer<typeof ChronicleEvent>;

export const ChronicleVoice = __t.object("ChronicleVoice", {
  eventId: __t.u64(),
  worldId: __t.u64(),
  text: __t.string(),
  toldAt: __t.timestamp(),
});
export type ChronicleVoice = __Infer<typeof ChronicleVoice>;

export const ClientCompat = __t.object("ClientCompat", {
  id: __t.u8(),
  rulesetVersion: __t.u32(),
  minClient: __t.string(),
  moduleVersion: __t.string(),
});
export type ClientCompat = __Infer<typeof ClientCompat>;

export const CollectedPiece = __t.object("CollectedPiece", {
  id: __t.u64(),
  identity: __t.identity(),
  def: __t.u16(),
  firstAt: __t.timestamp(),
  seen: __t.bool(),
});
export type CollectedPiece = __Infer<typeof CollectedPiece>;

export const CollectionLock = __t.object("CollectionLock", {
  id: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64(),
});
export type CollectionLock = __Infer<typeof CollectionLock>;

export const ControlGrant = __t.object("ControlGrant", {
  id: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  grantee: __t.identity(),
  grantedBy: __t.identity(),
  at: __t.timestamp(),
});
export type ControlGrant = __Infer<typeof ControlGrant>;

export const CrawlForce = __t.object("CrawlForce", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  debtXp: __t.u32(),
  forced: __t.array(__t.u16()),
  pending: __t.array(__t.u16()),
});
export type CrawlForce = __Infer<typeof CrawlForce>;

export const DiceGame = __t.object("DiceGame", {
  state: __t.u8(),
  stake: __t.u32(),
  pot: __t.u32(),
  kitty: __t.u32(),
  get seats() {
    return __t.array(DiceSeat);
  },
  turn: __t.i8(),
  dice: __t.byteArray(),
  thrown: __t.u8(),
  throwN: __t.u32(),
  pushes: __t.u8(),
  last: __t.u8(),
  deadlineUs: __t.i64(),
  gameN: __t.u32(),
  winners: __t.byteArray(),
});
export type DiceGame = __Infer<typeof DiceGame>;

export const DiceSeat = __t.object("DiceSeat", {
  kind: __t.u8(),
  state: __t.u8(),
  owner: __t.identity(),
  heroId: __t.u64(),
  name: __t.string(),
  frame: __t.u16(),
  class: __t.u8(),
  temper: __t.u8(),
  score: __t.u8(),
  hand: __t.byteArray(),
  won: __t.u32(),
});
export type DiceSeat = __Infer<typeof DiceSeat>;

export const DiceTable = __t.object("DiceTable", {
  villageId: __t.u64(),
  worldId: __t.u64(),
  get game() {
    return DiceGame;
  },
  at: __t.timestamp(),
});
export type DiceTable = __Infer<typeof DiceTable>;

export const EmoteClock = __t.object("EmoteClock", {
  owner: __t.identity(),
  at: __t.timestamp(),
});
export type EmoteClock = __Infer<typeof EmoteClock>;

export const Encounter = __t.object("Encounter", {
  id: __t.u64(),
  worldId: __t.u64(),
  partyId: __t.u64(),
  state: __t.u8(),
  pulseIndex: __t.u32(),
  snapshot: __t.byteArray(),
  snapshotHash: __t.byteArray(),
  declaration: __t.byteArray(),
  inputsHash: __t.byteArray(),
  outcome: __t.option(__t.u8()),
  openedAt: __t.timestamp(),
  endedAt: __t.option(__t.timestamp()),
  fleeCalled: __t.bool(),
  name: __t.string(),
  pendingSurrender: __t.bool(),
  boardW: __t.u8(),
  boardH: __t.u8(),
  instanceId: __t.option(__t.u64()),
  difficultyBp: __t.u16(),
  leaderNpc: __t.option(__t.u64()),
  regardStrip: __t.array(__t.string()),
});
export type Encounter = __Infer<typeof Encounter>;

export const EncounterBoon = __t.object("EncounterBoon", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  heroId: __t.u64(),
  card: __t.u16(),
});
export type EncounterBoon = __Infer<typeof EncounterBoon>;

export const EncounterHaul = __t.object("EncounterHaul", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  gold: __t.u32(),
  stashes: __t.u32(),
});
export type EncounterHaul = __Infer<typeof EncounterHaul>;

export const EncounterIdle = __t.object("EncounterIdle", {
  scheduledAtRow: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  encounterId: __t.u64(),
  seq: __t.u32(),
});
export type EncounterIdle = __Infer<typeof EncounterIdle>;

export const EncounterResult = __t.object("EncounterResult", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  heroId: __t.u64(),
  hpEnd: __t.i32(),
  downed: __t.bool(),
  dealt: __t.i32(),
  taken: __t.i32(),
  finalBlows: __t.u32(),
  xp: __t.u32(),
  gold: __t.u32(),
  outcome: __t.u8(),
  pulses: __t.u32(),
});
export type EncounterResult = __Infer<typeof EncounterResult>;

export const EncounterSecured = __t.object("EncounterSecured", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  pulse: __t.u32(),
  outcome: __t.u8(),
  at: __t.timestamp(),
  untilPulse: __t.u32(),
});
export type EncounterSecured = __Infer<typeof EncounterSecured>;

export const EncounterStage = __t.object("EncounterStage", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  kit: __t.string(),
  hour: __t.u8(),
  weather: __t.string(),
  viewSeed: __t.u32(),
  layoutSeed: __t.u64(),
  season: __t.u8(),
  country: __t.string(),
  look: __t.string(),
});
export type EncounterStage = __Infer<typeof EncounterStage>;

export const EncounterTruth = __t.object("EncounterTruth", {
  encounterId: __t.u64(),
  snapshot: __t.byteArray(),
  declaration: __t.byteArray(),
});
export type EncounterTruth = __Infer<typeof EncounterTruth>;

export const EncounterWeek = __t.object("EncounterWeek", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  beganWeek: __t.u64(),
  main: __t.bool(),
});
export type EncounterWeek = __Infer<typeof EncounterWeek>;

export const FinishVote = __t.object("FinishVote", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  owner: __t.identity(),
});
export type FinishVote = __Infer<typeof FinishVote>;

export const FirstEndings = __t.object("FirstEndings", {
  worldId: __t.u64(),
  jobId: __t.u64(),
  endings: __t.byteArray(),
});
export type FirstEndings = __Infer<typeof FirstEndings>;

export const FoeArmor = __t.object("FoeArmor", {
  id: __t.u64(),
  worldId: __t.u64(),
  npc: __t.u64(),
  percent: __t.u8(),
});
export type FoeArmor = __Infer<typeof FoeArmor>;

export const FoeFate = __t.object("FoeFate", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  npc: __t.u64(),
  name: __t.string(),
  fate: __t.u8(),
  pulse: __t.u32(),
  survivals: __t.u8(),
});
export type FoeFate = __Infer<typeof FoeFate>;

export const FoundingGoods = __t.object("FoundingGoods", {
  itemId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
});
export type FoundingGoods = __Infer<typeof FoundingGoods>;

export const FoundingKit = __t.object("FoundingKit", {
  itemId: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
});
export type FoundingKit = __Infer<typeof FoundingKit>;

export const FoundingMarket = __t.object("FoundingMarket", {
  id: __t.u64(),
  worldId: __t.u64(),
  slot: __t.u8(),
  n: __t.u64(),
  def: __t.u16(),
  tier: __t.u8(),
  name: __t.string(),
  price: __t.u32(),
});
export type FoundingMarket = __Infer<typeof FoundingMarket>;

export const FoundingOutfit = __t.object("FoundingOutfit", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  recruitFee: __t.u32(),
  boosts: __t.array(__t.u16()),
});
export type FoundingOutfit = __Infer<typeof FoundingOutfit>;

export const FoundingPurse = __t.object("FoundingPurse", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  spent: __t.u32(),
  open: __t.bool(),
  saved: __t.u32(),
  carrier: __t.u64(),
  openedAt: __t.timestamp(),
  closedAt: __t.option(__t.timestamp()),
});
export type FoundingPurse = __Infer<typeof FoundingPurse>;

export const Friendship = __t.object("Friendship", {
  id: __t.u64(),
  low: __t.identity(),
  high: __t.identity(),
  requestedBy: __t.identity(),
  state: __t.u8(),
  at: __t.timestamp(),
});
export type Friendship = __Infer<typeof Friendship>;

export const FrozenInstance = __t.object("FrozenInstance", {
  id: __t.u64(),
  worldId: __t.u64(),
  kind: __t.u8(),
  rulesetVersion: __t.u32(),
  seed: __t.byteArray(),
  briefHash: __t.byteArray(),
  blob: __t.byteArray(),
  blobHash: __t.byteArray(),
  certificate: __t.byteArray(),
  voiceFilled: __t.bool(),
  jobId: __t.u64(),
  frozenAt: __t.timestamp(),
});
export type FrozenInstance = __Infer<typeof FrozenInstance>;

export const GearMove = __t.object("GearMove", {
  itemId: __t.u64(),
  slot: __t.option(__t.u8()),
});
export type GearMove = __Infer<typeof GearMove>;

export const GearPlan = __t.object("GearPlan", {
  id: __t.u64(),
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  heroId: __t.u64(),
  get moves() {
    return __t.array(GearMove);
  },
  owner: __t.identity(),
});
export type GearPlan = __Infer<typeof GearPlan>;

export const GenerationJob = __t.object("GenerationJob", {
  id: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  subject: __t.u64(),
  inputsHash: __t.byteArray(),
  priority: __t.u8(),
  status: __t.u8(),
  worker: __t.option(__t.identity()),
  leaseUntil: __t.option(__t.timestamp()),
  attempts: __t.u8(),
  createdAt: __t.timestamp(),
  deliveredAt: __t.option(__t.timestamp()),
  note: __t.string(),
  inputs: __t.byteArray(),
  storyteller: __t.u8(),
});
export type GenerationJob = __Infer<typeof GenerationJob>;

export const HaulGold = __t.object("HaulGold", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  heroId: __t.u64(),
  gold: __t.u32(),
});
export type HaulGold = __Infer<typeof HaulGold>;

export const HaulItem = __t.object("HaulItem", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  fixture: __t.u16(),
  stash: __t.u8(),
  openedBy: __t.u64(),
  def: __t.u16(),
  tier: __t.u8(),
  name: __t.string(),
  relic: __t.bool(),
  value: __t.u32(),
  pile: __t.option(__t.u32()),
  itemId: __t.option(__t.u64()),
});
export type HaulItem = __Infer<typeof HaulItem>;

export const Hero = __t.object("Hero", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  name: __t.string(),
  class: __t.u8(),
  species: __t.u8(),
  build: __t.u8(),
  level: __t.u8(),
  xp: __t.u32(),
  gold: __t.u32(),
  shapeMark: __t.u8(),
  oryxFrame: __t.u16(),
  status: __t.u8(),
  activeEncounter: __t.option(__t.u64()),
  cards: __t.array(__t.u16()),
  createdAt: __t.timestamp(),
  fights: __t.u32(),
  victories: __t.u32(),
  finalBlows: __t.u32(),
  timesDowned: __t.u32(),
});
export type Hero = __Infer<typeof Hero>;

export const HeroBoon = __t.object("HeroBoon", {
  id: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
  card: __t.u16(),
  fightsLeft: __t.u8(),
  fromDef: __t.u16(),
  laidBy: __t.u64(),
  at: __t.timestamp(),
});
export type HeroBoon = __Infer<typeof HeroBoon>;

export const HeroCalling = __t.object("HeroCalling", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  pick: __t.u16(),
  spells: __t.array(__t.u16()),
  petName: __t.string(),
  petCoat: __t.u8(),
});
export type HeroCalling = __Infer<typeof HeroCalling>;

export const HeroDye = __t.object("HeroDye", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  dye: __t.u8(),
});
export type HeroDye = __Infer<typeof HeroDye>;

export const HeroEmote = __t.object("HeroEmote", {
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
  emote: __t.u8(),
  catalogue: __t.u32(),
  get cues() {
    return __t.array(SfxCueRow);
  },
});
export type HeroEmote = __Infer<typeof HeroEmote>;

export const HeroMeal = __t.object("HeroMeal", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  villageId: __t.u64(),
  orderedAt: __t.timestamp(),
  eaten: __t.bool(),
});
export type HeroMeal = __Infer<typeof HeroMeal>;

export const HeroOrigin = __t.object("HeroOrigin", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  background: __t.u8(),
  loadout: __t.u8(),
});
export type HeroOrigin = __Infer<typeof HeroOrigin>;

export const HeroPack = __t.object("HeroPack", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  grade: __t.u8(),
  capacity: __t.u8(),
});
export type HeroPack = __Infer<typeof HeroPack>;

export const HeroProgress = __t.object("HeroProgress", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  picks: __t.array(__t.u16()),
  training: __t.byteArray(),
  talents: __t.array(__t.u16()),
  laurels: __t.array(__t.u16()),
});
export type HeroProgress = __Infer<typeof HeroProgress>;

export const HeroRoute = __t.object("HeroRoute", {
  id: __t.u64(),
  encounterId: __t.u64(),
  heroId: __t.u64(),
  destX: __t.i32(),
  destY: __t.i32(),
  owner: __t.identity(),
  setAt: __t.timestamp(),
});
export type HeroRoute = __Infer<typeof HeroRoute>;

export const HeroVoiceRow = __t.object("HeroVoiceRow", {
  heroId: __t.u64(),
  worldId: __t.u64(),
  voice: __t.u8(),
});
export type HeroVoiceRow = __Infer<typeof HeroVoiceRow>;

export const InnCheer = __t.object("InnCheer", {
  worldId: __t.u64(),
  villageId: __t.u64(),
  owner: __t.identity(),
  kind: __t.u8(),
  heroId: __t.u64(),
  arg: __t.u8(),
  seed: __t.u32(),
});
export type InnCheer = __Infer<typeof InnCheer>;

export const InnGuestbook = __t.object("InnGuestbook", {
  id: __t.u64(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  owner: __t.identity(),
  heroName: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
});
export type InnGuestbook = __Infer<typeof InnGuestbook>;

export const InnNotice = __t.object("InnNotice", {
  id: __t.u64(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  owner: __t.identity(),
  heroName: __t.string(),
  title: __t.string(),
  text: __t.string(),
  paper: __t.u8(),
  at: __t.timestamp(),
});
export type InnNotice = __Infer<typeof InnNotice>;

export const InnRent = __t.object("InnRent", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  villageId: __t.u64(),
  paidAt: __t.timestamp(),
});
export type InnRent = __Infer<typeof InnRent>;

export const InnSong = __t.object("InnSong", {
  villageId: __t.u64(),
  worldId: __t.u64(),
  tune: __t.u8(),
  startedAt: __t.timestamp(),
  by: __t.string(),
});
export type InnSong = __Infer<typeof InnSong>;

export const InnVisit = __t.object("InnVisit", {
  villageId: __t.u64(),
  worldId: __t.u64(),
  seed: __t.u32(),
  since: __t.timestamp(),
  seen: __t.timestamp(),
});
export type InnVisit = __Infer<typeof InnVisit>;

export const IntentRow = __t.object("IntentRow", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  heroId: __t.u64(),
  slot: __t.u8(),
  action: __t.u16(),
  intent: __t.byteArray(),
  snapshotHash: __t.byteArray(),
  revision: __t.u32(),
  committed: __t.bool(),
  substituted: __t.bool(),
  owner: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type IntentRow = __Infer<typeof IntentRow>;

export const Item = __t.object("Item", {
  id: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
  def: __t.u16(),
  tier: __t.u8(),
  name: __t.string(),
  equippedSlot: __t.option(__t.u8()),
  relic: __t.bool(),
  bornEvent: __t.option(__t.u64()),
  acquiredAt: __t.timestamp(),
});
export type Item = __Infer<typeof Item>;

export const ItemDye = __t.object("ItemDye", {
  itemId: __t.u64(),
  worldId: __t.u64(),
  dye: __t.u8(),
});
export type ItemDye = __Infer<typeof ItemDye>;

export const ItemUpgrade = __t.object("ItemUpgrade", {
  itemId: __t.u64(),
  worldId: __t.u64(),
  applied: __t.array(__t.u16()),
  spent: __t.u32(),
});
export type ItemUpgrade = __Infer<typeof ItemUpgrade>;

export const JobTimeout = __t.object("JobTimeout", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type JobTimeout = __Infer<typeof JobTimeout>;

export const LevelUpOffer = __t.object("LevelUpOffer", {
  id: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
  toLevel: __t.u8(),
  cards: __t.array(__t.u16()),
  createdAt: __t.timestamp(),
});
export type LevelUpOffer = __Infer<typeof LevelUpOffer>;

export const LobbySeat = __t.object("LobbySeat", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  ready: __t.bool(),
  joinedAt: __t.timestamp(),
});
export type LobbySeat = __Infer<typeof LobbySeat>;

export const LocationStatus = __t.object("LocationStatus", {
  id: __t.u64(),
  worldId: __t.u64(),
  locationIndex: __t.u8(),
  name: __t.string(),
  condition: __t.i8(),
  adventures: __t.u32(),
  lastSentence: __t.string(),
});
export type LocationStatus = __Infer<typeof LocationStatus>;

export const LootDraw = __t.object("LootDraw", {
  id: __t.u64(),
  worldId: __t.u64(),
  instanceId: __t.u64(),
  heroId: __t.u64(),
  drawIndex: __t.u8(),
  table: __t.string(),
  values: __t.array(__t.u32()),
  itemId: __t.u64(),
  redrawn: __t.bool(),
  bumped: __t.bool(),
});
export type LootDraw = __Infer<typeof LootDraw>;

export const ModuleAdmin = __t.object("ModuleAdmin", {
  identity: __t.identity(),
  at: __t.timestamp(),
});
export type ModuleAdmin = __Infer<typeof ModuleAdmin>;

export const NamedCharacter = __t.object("NamedCharacter", {
  id: __t.u64(),
  worldId: __t.u64(),
  npc: __t.u64(),
  name: __t.string(),
  side: __t.u8(),
  rung: __t.u8(),
  survivals: __t.u8(),
  notability: __t.u16(),
  live: __t.bool(),
  protected: __t.bool(),
  lastLine: __t.string(),
  namedAt: __t.timestamp(),
  fights: __t.u32(),
});
export type NamedCharacter = __Infer<typeof NamedCharacter>;

export const Offer = __t.object("Offer", {
  id: __t.u64(),
  worldId: __t.u64(),
  slot: __t.u64(),
  archetype: __t.string(),
  title: __t.string(),
  pitch: __t.string(),
  asker: __t.string(),
  location: __t.string(),
  locationIndex: __t.u8(),
  minHumans: __t.u8(),
  maxHumans: __t.u8(),
  parMinutes: __t.u8(),
  side: __t.bool(),
  state: __t.u8(),
  expiresAt: __t.timestamp(),
  blob: __t.byteArray(),
  blobHash: __t.byteArray(),
  createdAt: __t.timestamp(),
});
export type Offer = __Infer<typeof Offer>;

export const OpeningCap = __t.object("OpeningCap", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  encounterId: __t.u64(),
});
export type OpeningCap = __Infer<typeof OpeningCap>;

export const Party = __t.object("Party", {
  id: __t.u64(),
  worldId: __t.u64(),
  lead: __t.identity(),
  name: __t.string(),
  planningWindowS: __t.u32(),
  allowPausing: __t.bool(),
  createdAt: __t.timestamp(),
  state: __t.u8(),
  encounterId: __t.option(__t.u64()),
  scenario: __t.u8(),
});
export type Party = __Infer<typeof Party>;

export const PartyMember = __t.object("PartyMember", {
  id: __t.u64(),
  worldId: __t.u64(),
  partyId: __t.u64(),
  owner: __t.identity(),
  heroId: __t.u64(),
  deployed: __t.bool(),
  shapeMark: __t.u8(),
  lead: __t.bool(),
});
export type PartyMember = __Infer<typeof PartyMember>;

export const PartyMessage = __t.object("PartyMessage", {
  id: __t.u64(),
  worldId: __t.u64(),
  partyId: __t.u64(),
  owner: __t.identity(),
  heroId: __t.option(__t.u64()),
  body: __t.string(),
  at: __t.timestamp(),
});
export type PartyMessage = __Infer<typeof PartyMessage>;

export const PartyWalk = __t.object("PartyWalk", {
  partyId: __t.u64(),
  worldId: __t.u64(),
  fromPlace: __t.i32(),
  toPlace: __t.i32(),
  departedAt: __t.timestamp(),
});
export type PartyWalk = __Infer<typeof PartyWalk>;

export const PartyWord = __t.object("PartyWord", {
  partyId: __t.u64(),
  worldId: __t.u64(),
  word: __t.byteArray(),
  fights: __t.u32(),
});
export type PartyWord = __Infer<typeof PartyWord>;

export const PauseState = __t.object("PauseState", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  allowed: __t.bool(),
  paused: __t.bool(),
  pausedBy: __t.option(__t.identity()),
  pausedAt: __t.option(__t.timestamp()),
  remainingMs: __t.u32(),
  pauseBudgetMs: __t.option(__t.u32()),
});
export type PauseState = __Infer<typeof PauseState>;

export const PlayerColour = __t.object("PlayerColour", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  colour: __t.u8(),
  chosenAt: __t.timestamp(),
});
export type PlayerColour = __Infer<typeof PlayerColour>;

export const PlayerProfile = __t.object("PlayerProfile", {
  identity: __t.identity(),
  username: __t.string(),
  createdAt: __t.timestamp(),
  online: __t.bool(),
  lastSeen: __t.timestamp(),
});
export type PlayerProfile = __Infer<typeof PlayerProfile>;

export const PlayerSetting = __t.object("PlayerSetting", {
  identity: __t.identity(),
  allowUncensored: __t.bool(),
  at: __t.timestamp(),
  killStreaks: __t.bool(),
});
export type PlayerSetting = __Infer<typeof PlayerSetting>;

export const Pulse = __t.object("Pulse", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  index: __t.u32(),
  state: __t.u8(),
  openedAt: __t.timestamp(),
  planningWindowS: __t.u32(),
  deadlineAt: __t.option(__t.timestamp()),
  graceUntil: __t.option(__t.timestamp()),
  locked: __t.bool(),
  lockReason: __t.u8(),
  snapshotHash: __t.byteArray(),
  planHash: __t.byteArray(),
  draws: __t.byteArray(),
  logBlob: __t.byteArray(),
  unready: __t.array(__t.identity()),
  unresolved: __t.byteArray(),
  seq: __t.u32(),
  lockedAt: __t.option(__t.timestamp()),
});
export type Pulse = __Infer<typeof Pulse>;

export const PulseDeadline = __t.object("PulseDeadline", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  seq: __t.u32(),
});
export type PulseDeadline = __Infer<typeof PulseDeadline>;

export const PulseGrace = __t.object("PulseGrace", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  seq: __t.u32(),
});
export type PulseGrace = __Infer<typeof PulseGrace>;

export const PulseTruth = __t.object("PulseTruth", {
  id: __t.u64(),
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  logBlob: __t.byteArray(),
  draws: __t.byteArray(),
});
export type PulseTruth = __Infer<typeof PulseTruth>;

export const PuzzleNote = __t.object("PuzzleNote", {
  id: __t.u64(),
  encounterId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.u8(),
  text: __t.string(),
  fixture: __t.option(__t.u16()),
  clue: __t.option(__t.u8()),
  cost: __t.u32(),
  by: __t.string(),
  at: __t.timestamp(),
});
export type PuzzleNote = __Infer<typeof PuzzleNote>;

export const PuzzleRoom = __t.object("PuzzleRoom", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  partyId: __t.u64(),
  genre: __t.string(),
  rule: __t.string(),
  weightRule: __t.string(),
  pieces: __t.array(__t.string()),
  clueTotal: __t.u8(),
  mapClues: __t.u8(),
  rewardXp: __t.u32(),
  debtXp: __t.u32(),
  par: __t.u16(),
  forced: __t.bool(),
  place: __t.string(),
  scene: __t.string(),
  freeHints: __t.u8(),
});
export type PuzzleRoom = __Infer<typeof PuzzleRoom>;

export const PuzzleSecret = __t.object("PuzzleSecret", {
  encounterId: __t.u64(),
  spec: __t.byteArray(),
});
export type PuzzleSecret = __Infer<typeof PuzzleSecret>;

export const QuestDraft = __t.object("QuestDraft", {
  id: __t.u64(),
  worldId: __t.u64(),
  chapter: __t.u8(),
  branch: __t.u8(),
  jobId: __t.u64(),
  season: __t.u8(),
  quest: __t.byteArray(),
  failed: __t.bool(),
});
export type QuestDraft = __Infer<typeof QuestDraft>;

export const QuestPing = __t.object("QuestPing", {
  worldId: __t.u64(),
  instanceId: __t.u64(),
  owner: __t.identity(),
  x: __t.i32(),
  y: __t.i32(),
  kind: __t.u8(),
});
export type QuestPing = __Infer<typeof QuestPing>;

export const QuestStage = __t.object("QuestStage", {
  offerId: __t.u64(),
  worldId: __t.u64(),
  chapter: __t.u8(),
  hour: __t.u8(),
  weather: __t.string(),
  whyNow: __t.string(),
  source: __t.u8(),
  postedWeek: __t.u64(),
  timeJumpWeeks: __t.u8(),
  timeJump: __t.string(),
});
export type QuestStage = __Infer<typeof QuestStage>;

export const QuestWait = __t.object("QuestWait", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  worldId: __t.u64(),
  jobId: __t.u64(),
});
export type QuestWait = __Infer<typeof QuestWait>;

export const QuestWound = __t.object("QuestWound", {
  id: __t.u64(),
  worldId: __t.u64(),
  instanceId: __t.u64(),
  heroId: __t.u64(),
  lost: __t.i32(),
  hpMax: __t.i32(),
});
export type QuestWound = __Infer<typeof QuestWound>;

export const RegardRow = __t.object("RegardRow", {
  id: __t.u64(),
  worldId: __t.u64(),
  npc: __t.u64(),
  subjectKind: __t.u8(),
  subjectId: __t.u64(),
  grudge: __t.u8(),
  debt: __t.u8(),
  fear: __t.u8(),
  respect: __t.u8(),
  familiarity: __t.u8(),
  knowledge: __t.array(__t.u16()),
  lastMovedWeek: __t.u64(),
  tension: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type RegardRow = __Infer<typeof RegardRow>;

export const RelicName = __t.object("RelicName", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  haulItemId: __t.u64(),
  itemId: __t.option(__t.u64()),
  def: __t.u16(),
  name: __t.string(),
  lore: __t.string(),
  tags: __t.array(__t.string()),
  leader: __t.string(),
  jobId: __t.u64(),
  written: __t.bool(),
  at: __t.timestamp(),
});
export type RelicName = __Infer<typeof RelicName>;

export const ResolutionLogRow = __t.object("ResolutionLogRow", {
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  log: __t.byteArray(),
  events: __t.byteArray(),
  ended: __t.option(__t.u8()),
});
export type ResolutionLogRow = __Infer<typeof ResolutionLogRow>;

export const RewardDeadline = __t.object("RewardDeadline", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  encounterId: __t.u64(),
});
export type RewardDeadline = __Infer<typeof RewardDeadline>;

export const RewardDivision = __t.object("RewardDivision", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  state: __t.u8(),
  outcome: __t.u8(),
  xpEach: __t.u32(),
  piles: __t.u32(),
  lost: __t.bool(),
  openedAt: __t.timestamp(),
  deadlineAt: __t.timestamp(),
  givenAt: __t.option(__t.timestamp()),
});
export type RewardDivision = __Infer<typeof RewardDivision>;

export const RewardLock = __t.object("RewardLock", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  owner: __t.identity(),
});
export type RewardLock = __Infer<typeof RewardLock>;

export const RewardPile = __t.object("RewardPile", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  index: __t.u32(),
  gold: __t.u32(),
  value: __t.u32(),
  heroId: __t.option(__t.u64()),
  soldGold: __t.u32(),
});
export type RewardPile = __Infer<typeof RewardPile>;

export const SeatAsk = __t.object("SeatAsk", {
  seat: __t.u16(),
  heroId: __t.u64(),
});
export type SeatAsk = __Infer<typeof SeatAsk>;

export const ServiceIdentity = __t.object("ServiceIdentity", {
  identity: __t.identity(),
  role: __t.u8(),
  label: __t.string(),
  registeredBy: __t.identity(),
  at: __t.timestamp(),
});
export type ServiceIdentity = __Infer<typeof ServiceIdentity>;

export const Settlement = __t.object("Settlement", {
  instanceId: __t.u64(),
  worldId: __t.u64(),
  outcomeRow: __t.u8(),
  settledAt: __t.timestamp(),
  xpEach: __t.u32(),
  goldEach: __t.u32(),
});
export type Settlement = __Infer<typeof Settlement>;

export const SfxCueRow = __t.object("SfxCueRow", {
  bank: __t.string(),
  variant: __t.u16(),
  anchor: __t.u8(),
  seq: __t.u32(),
  beat: __t.u8(),
  step: __t.u8(),
  delayMs: __t.u16(),
  gainBp: __t.u16(),
  rateBp: __t.u16(),
  unit: __t.option(__t.u16()),
});
export type SfxCueRow = __Infer<typeof SfxCueRow>;

export const SfxScore = __t.object("SfxScore", {
  worldId: __t.u64(),
  partyId: __t.u64(),
  encounterId: __t.u64(),
  pulseIndex: __t.u32(),
  catalogue: __t.u32(),
  get cues() {
    return __t.array(SfxCueRow);
  },
});
export type SfxScore = __Infer<typeof SfxScore>;

export const ShelfWorld = __t.object("ShelfWorld", {
  worldId: __t.u64(),
  band: __t.u8(),
  madeAt: __t.timestamp(),
  checkedAt: __t.timestamp(),
  status: __t.string(),
});
export type ShelfWorld = __Infer<typeof ShelfWorld>;

export const SideWriting = __t.object("SideWriting", {
  jobId: __t.u64(),
  worldId: __t.u64(),
  count: __t.u8(),
});
export type SideWriting = __Infer<typeof SideWriting>;

export const SpoilsSkim = __t.object("SpoilsSkim", {
  id: __t.u64(),
  worldId: __t.u64(),
  encounterId: __t.u64(),
  heroId: __t.u64(),
  gold: __t.u32(),
});
export type SpoilsSkim = __Infer<typeof SpoilsSkim>;

export const StoryLedger = __t.object("StoryLedger", {
  id: __t.u64(),
  worldId: __t.u64(),
  book: __t.u8(),
  kind: __t.u8(),
  position: __t.u8(),
  text: __t.string(),
  met: __t.bool(),
  week: __t.u64(),
  at: __t.timestamp(),
});
export type StoryLedger = __Infer<typeof StoryLedger>;

export const StoryShelf = __t.object("StoryShelf", {
  id: __t.u64(),
  band: __t.u8(),
  jobId: __t.u64(),
  genesis: __t.byteArray(),
  madeAt: __t.timestamp(),
});
export type StoryShelf = __Infer<typeof StoryShelf>;

export const StoryVault = __t.object("StoryVault", {
  worldId: __t.u64(),
  genesis: __t.byteArray(),
});
export type StoryVault = __Infer<typeof StoryVault>;

export const StoryWait = __t.object("StoryWait", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  worldId: __t.u64(),
  jobId: __t.u64(),
});
export type StoryWait = __Infer<typeof StoryWait>;

export const TalkTopic = __t.object("TalkTopic", {
  ask: __t.string(),
  answer: __t.string(),
  about: __t.string(),
  followAsk: __t.string(),
  followAnswer: __t.string(),
});
export type TalkTopic = __Infer<typeof TalkTopic>;

export const TradeOffer = __t.object("TradeOffer", {
  id: __t.u64(),
  worldId: __t.u64(),
  fromHero: __t.u64(),
  fromOwner: __t.identity(),
  toHero: __t.u64(),
  toOwner: __t.identity(),
  giveItems: __t.array(__t.u64()),
  giveGold: __t.u32(),
  askItems: __t.array(__t.u64()),
  askGold: __t.u32(),
  note: __t.string(),
  state: __t.u8(),
  reason: __t.string(),
  createdAt: __t.timestamp(),
  settledAt: __t.option(__t.timestamp()),
});
export type TradeOffer = __Infer<typeof TradeOffer>;

export const UpgradeGift = __t.object("UpgradeGift", {
  id: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
  upgrade: __t.u16(),
  giver: __t.string(),
  givenAt: __t.timestamp(),
});
export type UpgradeGift = __Infer<typeof UpgradeGift>;

export const Village = __t.object("Village", {
  id: __t.u64(),
  worldId: __t.u64(),
  index: __t.u8(),
  locationIndex: __t.u8(),
  place: __t.i32(),
  size: __t.u8(),
  state: __t.u8(),
  name: __t.string(),
  epithet: __t.string(),
  text: __t.string(),
  inn: __t.string(),
  shop: __t.string(),
  smithy: __t.string(),
  temple: __t.string(),
  talkSig: __t.byteArray(),
  talkWriting: __t.bool(),
  alarm: __t.string(),
  alarmNpc: __t.u64(),
  alarmOffer: __t.u64(),
  troubles: __t.array(__t.string()),
  rolledWeek: __t.u64(),
  stockWeek: __t.u64(),
  writtenAt: __t.timestamp(),
});
export type Village = __Infer<typeof Village>;

export const VillageFigure = __t.object("VillageFigure", {
  heroId: __t.u64(),
  beast: __t.bool(),
  line: __t.array(__t.f32()),
  s: __t.f32(),
  to: __t.f32(),
  speed: __t.f32(),
  face: __t.i8(),
  seated: __t.bool(),
  act: __t.u8(),
  held: __t.u8(),
});
export type VillageFigure = __Infer<typeof VillageFigure>;

export const VillageFigures = __t.object("VillageFigures", {
  owner: __t.identity(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  spot: __t.u8(),
  get figures() {
    return __t.array(VillageFigure);
  },
  talkNpc: __t.u64(),
  at: __t.timestamp(),
});
export type VillageFigures = __Infer<typeof VillageFigures>;

export const VillageKnown = __t.object("VillageKnown", {
  id: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64(),
  npcId: __t.u64(),
  kind: __t.u8(),
  text: __t.string(),
  about: __t.string(),
  at: __t.timestamp(),
});
export type VillageKnown = __Infer<typeof VillageKnown>;

export const VillageMoment = __t.object("VillageMoment", {
  worldId: __t.u64(),
  villageId: __t.u64(),
  spot: __t.u8(),
  owner: __t.identity(),
  kind: __t.u8(),
  heroId: __t.u64(),
  x: __t.f32(),
  y: __t.f32(),
  seed: __t.u32(),
  at: __t.timestamp(),
});
export type VillageMoment = __Infer<typeof VillageMoment>;

export const VillageNpc = __t.object("VillageNpc", {
  id: __t.u64(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  slot: __t.u8(),
  role: __t.u8(),
  building: __t.u8(),
  deal: __t.u8(),
  frame: __t.u16(),
  name: __t.string(),
  epithet: __t.string(),
  goods: __t.string(),
  price: __t.u32(),
  hireClass: __t.u8(),
  tradeDef: __t.u16(),
  tradeTier: __t.u8(),
  dealPitch: __t.string(),
  dealYes: __t.string(),
  dealNo: __t.string(),
  farewell: __t.string(),
  greeting: __t.string(),
  get topics() {
    return __t.array(TalkTopic);
  },
  secretTeaser: __t.string(),
  secretAbout: __t.string(),
  pours: __t.bool(),
  state: __t.u8(),
  joinedHero: __t.u64(),
});
export type VillageNpc = __Infer<typeof VillageNpc>;

export const VillagePresence = __t.object("VillagePresence", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  villageId: __t.u64(),
  spot: __t.u8(),
  x: __t.f32(),
  y: __t.f32(),
  pose: __t.u8(),
  movedBy: __t.identity(),
  at: __t.timestamp(),
});
export type VillagePresence = __Infer<typeof VillagePresence>;

export const VillageSeat = __t.object("VillageSeat", {
  id: __t.u64(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  spot: __t.u8(),
  seat: __t.u16(),
  owner: __t.identity(),
  heroId: __t.u64(),
  at: __t.timestamp(),
});
export type VillageSeat = __Infer<typeof VillageSeat>;

export const VillageSecret = __t.object("VillageSecret", {
  npcId: __t.u64(),
  worldId: __t.u64(),
  secret: __t.string(),
  round: __t.string(),
});
export type VillageSecret = __Infer<typeof VillageSecret>;

export const VillageStock = __t.object("VillageStock", {
  id: __t.u64(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  building: __t.u8(),
  week: __t.u64(),
  def: __t.u16(),
  tier: __t.u8(),
  name: __t.string(),
  price: __t.u32(),
  sold: __t.bool(),
});
export type VillageStock = __Infer<typeof VillageStock>;

export const VillageTrouble = __t.object("VillageTrouble", {
  villageId: __t.u64(),
  worldId: __t.u64(),
  happening: __t.byteArray(),
  used: __t.bool(),
});
export type VillageTrouble = __Infer<typeof VillageTrouble>;

export const VillageWorkshop = __t.object("VillageWorkshop", {
  id: __t.u64(),
  worldId: __t.u64(),
  villageId: __t.u64(),
  shop: __t.u8(),
  keeper: __t.string(),
  frame: __t.u16(),
  offers: __t.array(__t.u16()),
});
export type VillageWorkshop = __Infer<typeof VillageWorkshop>;

export const VillageWriting = __t.object("VillageWriting", {
  jobId: __t.u64(),
  villageId: __t.u64(),
  worldId: __t.u64(),
  boardSig: __t.byteArray(),
});
export type VillageWriting = __Infer<typeof VillageWriting>;

export const VoicePending = __t.object("VoicePending", {
  eventId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  facts: __t.string(),
  quote: __t.string(),
  jobId: __t.u64(),
});
export type VoicePending = __Infer<typeof VoicePending>;

export const WildLeg = __t.object("WildLeg", {
  at: __t.i64(),
  ms: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  z: __t.i32(),
  gait: __t.u8(),
});
export type WildLeg = __Infer<typeof WildLeg>;

export const WildRoom = __t.object("WildRoom", {
  encounterId: __t.u64(),
  next: __t.array(__t.i64()),
});
export type WildRoom = __Infer<typeof WildRoom>;

export const WildTick = __t.object("WildTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  encounterId: __t.u64(),
});
export type WildTick = __Infer<typeof WildTick>;

export const Wildlife = __t.object("Wildlife", {
  id: __t.u64(),
  encounterId: __t.u64(),
  species: __t.u8(),
  seed: __t.u32(),
  get legs() {
    return __t.array(WildLeg);
  },
  untilMs: __t.i64(),
  homeX: __t.i32(),
  homeY: __t.i32(),
  attend: __t.option(__t.u16()),
  leaving: __t.bool(),
});
export type Wildlife = __Infer<typeof Wildlife>;

export const WonderBlessing = __t.object("WonderBlessing", {
  id: __t.u64(),
  worldId: __t.u64(),
  heroId: __t.u64(),
  owner: __t.identity(),
  encounterId: __t.u64(),
  wonder: __t.string(),
  options: __t.array(__t.u16()),
  names: __t.array(__t.string()),
  blurbs: __t.array(__t.string()),
  chosen: __t.option(__t.u8()),
  at: __t.timestamp(),
});
export type WonderBlessing = __Infer<typeof WonderBlessing>;

export const WorkerBeat = __t.object("WorkerBeat", {
  identity: __t.identity(),
  at: __t.timestamp(),
});
export type WorkerBeat = __Infer<typeof WorkerBeat>;

export const World = __t.object("World", {
  id: __t.u64(),
  name: __t.string(),
  owner: __t.identity(),
  worldSeed: __t.byteArray(),
  createdAt: __t.timestamp(),
  chronicleSeq: __t.u64(),
  heroesPerHuman: __t.u8(),
  storyteller: __t.u8(),
});
export type World = __Infer<typeof World>;

export const WorldClock = __t.object("WorldClock", {
  worldId: __t.u64(),
  weekIndex: __t.u64(),
  year: __t.u32(),
  season: __t.u8(),
  week: __t.u8(),
  seasonName: __t.string(),
  seasonNames: __t.array(__t.string()),
  reckoning: __t.string(),
  biome: __t.string(),
  temperature: __t.string(),
  climate: __t.string(),
  weather: __t.string(),
  startIndex: __t.u64(),
  changedAt: __t.timestamp(),
});
export type WorldClock = __Infer<typeof WorldClock>;

export const WorldInvite = __t.object("WorldInvite", {
  id: __t.u64(),
  worldId: __t.u64(),
  from: __t.identity(),
  to: __t.identity(),
  at: __t.timestamp(),
});
export type WorldInvite = __Infer<typeof WorldInvite>;

export const WorldMember = __t.object("WorldMember", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  joinedAt: __t.timestamp(),
  displayName: __t.string(),
});
export type WorldMember = __Infer<typeof WorldMember>;

export const WorldMessage = __t.object("WorldMessage", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  kind: __t.u8(),
  body: __t.string(),
  at: __t.timestamp(),
});
export type WorldMessage = __Infer<typeof WorldMessage>;

export const WorldOmen = __t.object("WorldOmen", {
  id: __t.u64(),
  worldId: __t.u64(),
  text: __t.string(),
  source: __t.string(),
  used: __t.bool(),
  foundAt: __t.timestamp(),
});
export type WorldOmen = __Infer<typeof WorldOmen>;

export const WorldOpening = __t.object("WorldOpening", {
  worldId: __t.u64(),
  phase: __t.u8(),
  ready: __t.array(__t.identity()),
  partyId: __t.u64(),
  instanceId: __t.u64(),
  encounterId: __t.u64(),
  outcomeRow: __t.option(__t.u8()),
  campaignOffer: __t.u64(),
  heroes: __t.array(__t.u64()),
});
export type WorldOpening = __Infer<typeof WorldOpening>;

export const WorldOptions = __t.object("WorldOptions", {
  name: __t.string(),
  seedPhrase: __t.string(),
  description: __t.string(),
  visibility: __t.u8(),
  maxPlayers: __t.u8(),
  heroesPerHuman: __t.u8(),
  planningWindowS: __t.u32(),
  allowPausing: __t.bool(),
  xpRatePct: __t.u16(),
  perilPct: __t.u16(),
  lateJoin: __t.bool(),
  startingGold: __t.u32(),
});
export type WorldOptions = __Infer<typeof WorldOptions>;

export const WorldPing = __t.object("WorldPing", {
  worldId: __t.u64(),
  owner: __t.identity(),
  x: __t.i32(),
  y: __t.i32(),
  kind: __t.u8(),
});
export type WorldPing = __Infer<typeof WorldPing>;

export const WorldPresence = __t.object("WorldPresence", {
  id: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  seenAt: __t.timestamp(),
  screen: __t.string(),
});
export type WorldPresence = __Infer<typeof WorldPresence>;

export const WorldSettings = __t.object("WorldSettings", {
  worldId: __t.u64(),
  phase: __t.u8(),
  get options() {
    return WorldOptions;
  },
  openedAt: __t.timestamp(),
  begunAt: __t.option(__t.timestamp()),
});
export type WorldSettings = __Infer<typeof WorldSettings>;

export const WorldStory = __t.object("WorldStory", {
  worldId: __t.u64(),
  state: __t.u8(),
  source: __t.u8(),
  genesis: __t.byteArray(),
  jobId: __t.u64(),
  requestedAt: __t.timestamp(),
  waitUntil: __t.timestamp(),
  toldAt: __t.option(__t.timestamp()),
  trouble: __t.string(),
});
export type WorldStory = __Infer<typeof WorldStory>;

